/**
 * A foto redonda de um representante; sem foto (ou se ela não carregar), as iniciais.
 *
 * Lê: só as props (foto = endereço vindo de /api/cadastros.php).
 * Usado por: telas/Representante.tsx e telas/cadastros/Representantes.tsx.
 */
import { useState } from 'react';
import { iniciais } from '../formatacao.ts';

export function Avatar({ nome, foto, tamanho = 32 }: { nome: string; foto?: string | null; tamanho?: number }) {
  const [falhou, setFalhou] = useState<string | null>(null);
  const comFoto = foto && falhou !== foto;
  return (
    <span className="avatar" style={{ width: tamanho, height: tamanho, fontSize: Math.round(tamanho * 0.38) }} aria-hidden="true">
      {comFoto ? <img src={foto} alt="" width={tamanho} height={tamanho} onError={() => setFalhou(foto)} /> : iniciais(nome)}
    </span>
  );
}
